<template>
  <TextField
      :value="value"
      :name="label"
      :placeholder="placeholder"
      :suffix="suffix"
      :required="required"
      :rules="rules"
      :simple="simple"
      @keypress="onKeyPress"
      @input="onInput"
      style="width: 240px"
  />
</template>

<script>
import TextField from "@/components/atoms/TextField";
export default {
  name: "NumberField",
  components: {TextField},
  props: {
    value: {
      type: Number | null,
      required: true
    },
    label: {
      type: String,
      default: "年収"
    },
    placeholder: {
      type: String
    },
    suffix: {
      type: String,
      default: "万円"
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onKeyPress(event) {
      event = event ? event : window.event;
      const code = event.which ? event.which : event.keyCode;
      if (code >= '0'.charCodeAt(0) && code <= '9'.charCodeAt(0)) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    onInput (value) {
      value = this.toNumberString(value);
      if (value && !parseInt(value)) {
        value = null;
      }
      this.$emit("input", value ? parseInt(value) : null)
    },
    toNumberString(text) {
      if (text) {
        return text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
      }
      return text;
    }
  }
}
</script>

<style scoped>

</style>